import React, { memo } from 'react';
import { createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import SummaryBox from './SummaryBox';
import { TABLES } from '../../../constants';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'Summary');

const defaultSettings = {
    users: {
        text: 'label_sage_summary_1',
        text2: 'label_sage_summary_1_variable',
    },
    accountTypes: {
        text: 'label_sage_summary_2',
        text2: 'label_sage_summary_2_variable',
    },
    orderStatus: {
        text: 'label_sage_summary_3',
        text2: 'label_sage_summary_3_variable',
    },
    opportunityStatus: {
        text: 'label_sage_summary_4',
        text2: 'label_sage_summary_4_variable',
    },
};

const Summary = memo(({ count = {}, settings = defaultSettings }) => {
    const classes = useStyles();
    const theme = useTheme();

    const info = [
        {
            icon: 'emailSendOutline',
            iconColor: theme.colors.actionMajor[450],
            secondaryColor: theme.colors.semantic.positive500,
            param: count[TABLES.INVITED_USERS],
            ...settings.users,
        },
        {
            icon: 'branchCheck',
            iconColor: theme.colors.actionMajor[450],
            secondaryColor: theme.colors.semantic.positive500,
            param: count[TABLES.ACCOUNT_TYPES],
            ...settings.accountTypes,
        },
        {
            icon: 'quotesOutlined',
            iconColor: theme.colors.actionMajor[450],
            secondaryColor: theme.colors.semantic.positive500,
            param: count[TABLES.SALES_ORDER_STATUS],
            ...settings.orderStatus,
        },
        {
            icon: 'databaseExport',
            iconColor: theme.colors.actionMajor[450],
            secondaryColor: theme.colors.semantic.positive500,
            param: count[TABLES.OPPORTUNITY_STATUS],
            ...settings.opportunityStatus,
        },
    ];

    return (
        <div className={classes.container}>
            {info.map((section, index) => (
                <SummaryBox key={index} {...section} />
            ))}
        </div>
    );
});

export default Summary;
